module.exports = __webpack_public_path__ + "img/www.uk.trustpilot.com.b40eadda.png";